import { FC, useState } from "react";
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import { centsToFloat, floatToPrice } from "../../functions/price_functions";
import "./index.css";
import { products, vendorCart } from "../../pages/SellerOrders";
import { cpfMask, datetimeToDateBR } from "../../functions/mask";
import { ShareIcon } from "../MenuIcons/ShareIcon";
import { MainButton } from "../MainButton";
import CopyToClipboard from "react-copy-to-clipboard";
import Swal from "sweetalert2";
import { MeasureType } from "../../contexts/OrderContext";

type vendorOrderItemProps = {
  order: any;
  fontStatus?: string;
  colorStatus?: string;
  colorActiveStatus?: string;
};

type jsonCart2 = {
  products: jsonCart[];
};

type jsonCart = {
  id: number;
  name: string;
  img: string;
  sku: string;
  price: number;
  unitPrice: number;
  discout: number;
  discountGeral: number;
  promotional_price: number;
  quantity: number;
  code: string;
  promotionalPrice: number;
  variation: Variation[];
  discount: number;
  sku_info: Skuinfo[];
};
interface Skuinfo {
  vendas?: any;
  inventory: number;
  minimum_stock?: any;
  measures?: MeasureType;
}

interface Variation {
  grid: string;
  valor: string;
}

export function VendorOrderItem({
  order,
  colorStatus,
  colorActiveStatus,
  fontStatus,
}: vendorOrderItemProps) {
  const [extended, setExtended] = useState(false);

  const calculateTotal = (
    produtos: jsonCart[],
    discount: number,
    pedido: any
  ) => {
    let total = 0;

    for (const product of produtos) {
      const price = product.promotionalPrice
        ? product.promotionalPrice
        : product.price
        ? product.price
        : product.unitPrice;

      total += price * product.quantity;
    }

    let entrega = 0;
    if (pedido.Order) {
      entrega = centsToFloat(parseFloat(pedido.Order.deliveryTax));
    } else {
      entrega = pedido.jsonCart?.freight ? pedido.jsonCart?.freight : 0;
    }

    return total + discount + entrega;
  };

  const calculateTotalDiscount = (produtos: jsonCart[]) => {
    let total = 0;

    for (const product of produtos) {
      const discount = product.discountGeral ? product.discountGeral : 0;

      total += discount * product.quantity;
    }
    return total;
  };

  const status = (order: any) => {
    if (order.status === "canceled") {
      return "rejected";
    }

    if (order.status === "open") {
      return "pending";
    }
    return "confirmed";
  };

  const statusToPortugues = (order: any) => {
    if (order.status === "canceled") {
      return "Rejeitado";
    }

    if (order.status === "open") {
      return "Pendente";
    }

    return "Pago";
  };

  function calcValueProduct(product: jsonCart) {
    const price = product.promotionalPrice
      ? product.promotionalPrice
      : product.price
      ? product.price
      : product.unitPrice;

    return floatToPrice(price * product.quantity);
  }

  function customerName(order: any) {
    let name = "";

    name = order.Order?.Customer?.name
      ? order.Order.Customer.name
      : order?.Customer?.name
      ? order?.Customer?.name
      : order.customerName;

    return name || "Cliente não encontrado";
  }

  return (
    <div className="order-finded-vendor">
      <div
        className="number-order status-order"
        onClick={() => {
          setExtended(!extended);
        }}
      >
        <div className="clientName">
          <span className="code">Cliente: {customerName(order)}</span>
        </div>
        <div className="status">
          <p className={`${status(order)}`}>{statusToPortugues(order)}</p>
          {extended ? (
            <FaMinusCircle color="#636363" />
          ) : (
            <FaPlusCircle color="#636363" />
          )}
        </div>
      </div>
      {extended && (
        <div className="order-content">
          <div id="resumoCompra" className="resumoCompra">
            <div className="resumoCompraTitulo">
              <h3>Resumo da Compra</h3>
            </div>
            <div id="itensCompra" className="itensCompra">
              {order.order != 0 && (
                <div className="orderInfo">
                  <div className="pedido">
                    <span>Nº do Pedido </span>
                    <span>{order.order} </span>
                  </div>
                  {order?.Order?.status && (
                    <div className="pedido">
                      <span>Status do Pedido </span>
                      <span
                        style={{
                          background:
                            order.Order.status.colorSetting.background,
                          boxSizing: "content-box",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          borderRadius: "8px",
                        }}
                      >
                        {order.Order.status.name}{" "}
                      </span>
                    </div>
                  )}
                </div>
              )}
              {order.jsonCart.products ? (
                <>
                  {order.jsonCart.products.map((produto: jsonCart) => {
                    return (
                      <div className="produto">
                        <span className="productName">
                          {produto.name} ({produto.quantity}x) <br />
                          {`SKU: ${produto.sku}`}
                        </span>
                        <span className="priceProdutcs">
                          {calcValueProduct(produto)}
                        </span>
                      </div>
                    );
                  })}
                </>
              ) : (
                <>
                  {order.jsonCart.map((produto: jsonCart) => {
                    return (
                      <div className="produto">
                        <span>
                          {produto.name} x {produto.quantity}{" "}
                        </span>
                        <span>
                          {floatToPrice(produto.price * produto.quantity)}
                        </span>
                      </div>
                    );
                  })}
                </>
              )}

              <div className="produto">
                <span>Descontos</span>
                <span>
                  {floatToPrice(
                    calculateTotalDiscount(
                      order.jsonCart.products
                        ? order.jsonCart.products
                        : order.jsonCart
                    )
                  )}
                </span>
              </div>
              {order.jsonCart.freight ? (
                <div className="produto">
                  <span>Taxa da entrega</span>
                  <span>
                    {floatToPrice(parseFloat(order.jsonCart.freight))}
                  </span>
                </div>
              ) : (
                <div className="produto">
                  <span>Taxa da entrega</span>
                  <span>
                    {floatToPrice(
                      order?.Order?.deliveryTax
                        ? centsToFloat(parseFloat(order?.Order?.deliveryTax))
                        : 0
                    )}
                  </span>
                </div>
              )}
              <div id="TotalShop" className="total">
                <span>Total da Compra</span>
                <span>
                  {floatToPrice(
                    calculateTotal(
                      order.jsonCart.products
                        ? order.jsonCart.products
                        : order.jsonCart,
                      calculateTotalDiscount(
                        order.jsonCart.products
                          ? order.jsonCart.products
                          : order.jsonCart
                      ),
                      order
                    )
                  )}
                </span>
              </div>
            </div>
          </div>

          <InfoCustomer order={order} />

          {/* order.Order?.Customer ? (<>
                        <div id="clienteDados" className="resumoCliente">


                            <div className="clienteDadosTitulo">
                                <h3>Dados do Cliente</h3>
                            </div>
                            {order.jsonCart?.address?.address ? (
                                <div id="clienteDadosInfo" className="clienteDadosInfo">
                                    <span>Nome: {order.Customer.name}</span>
                                    <span>Documento: {cpfMask(order.Customer.doc)}</span>
                                    <span>Email: {order.Customer.email}</span>

                                    <div id="clienteDadosEndereco" className="clienteDadosEnderecoMain">

                                        <div className="clienteDadosEndereco">
                                            <span>Tipo : {order.jsonCart.address?.typeAddress === 'main' ? 'Casa' : 'Entrega'}</span>
                                            <span>Distrito: {order.jsonCart.address?.district}</span>
                                            <span>Estado: {order.jsonCart.address?.state}</span>

                                        </div>

                                        <div className="clienteDadosEndereco">
                                            <span>Cidade: {order.jsonCart.address?.city} </span>
                                            <span>Rua: {order.jsonCart.address?.address} </span>
                                            <span>Nº {order.jsonCart.address?.number}</span>

                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div id="clienteDadosInfo" className="clienteDadosInfo">
                                    <span>Nome: {order.Order.Customer.name}</span>
                                    <span>Documento: {cpfMask(order.Order.Customer.doc)}</span>
                                    <span>Email: {order.Order.Customer.email}</span>

                                    <div id="clienteDadosEndereco" className="clienteDadosEnderecoMain">

                                        <div className="clienteDadosEndereco">
                                            <span>Tipo : {order.Order.Customer.customerAddress?.typeAddress === 'main' ? 'Casa' : 'Entrega'}</span>
                                            <span>Distrito: {order.Order.Customer.customerAddress?.district}</span>
                                            <span>Estado: {order.Order.Customer.customerAddress?.state}</span>

                                        </div>

                                        <div className="clienteDadosEndereco">
                                            <span>Cidade: {order.Order.Customer.customerAddress?.city} </span>
                                            <span>Rua: {order.Order.Customer.customerAddress?.street} </span>
                                            <span>Nº {order.Order.Customer.customerAddress?.number}</span>

                                        </div>
                                    </div>
                                </div>
                            )

                            }
                        </div>

                    </>) : (
                        <div id="clienteDados" className="resumoCliente">


                            <div className="clienteDadosTitulo">
                                <h3>Dados do Cliente</h3>
                            </div>
                            {order.jsonCart.address?.address ? (
                                <div id="clienteDadosInfo" className="clienteDadosInfo">
                                    <span>Nome: {order.Customer.name}</span>
                                    <span>Documento: {cpfMask(order.Customer.doc)}</span>
                                    <span>Email: {order.Customer.email}</span>

                                    <div id="clienteDadosEndereco" className="clienteDadosEnderecoMain">

                                        <div className="clienteDadosEndereco">
                                            <span>Tipo : {order.jsonCart.address?.typeAddress === 'main' ? 'Casa' : 'Entrega'}</span>
                                            <span>Distrito: {order.jsonCart.address?.district}</span>
                                            <span>Estado: {order.jsonCart.address?.state}</span>

                                        </div>

                                        <div className="clienteDadosEndereco">
                                            <span>Cidade: {order.jsonCart.address?.city} </span>
                                            <span>Rua: {order.jsonCart.address?.address} </span>
                                            <span>Nº {order.jsonCart.address?.number}</span>

                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div id="clienteDadosInfo" className="clienteDadosInfo">
                                    <span>Nome: {order.Customer.name}</span>
                                    <span>Documento: {cpfMask(order.Customer.doc)}</span>
                                    <span>Email: {order.Customer.email}</span>

                                    <div id="clienteDadosEndereco" className="clienteDadosEnderecoMain">

                                        <div className="clienteDadosEndereco">
                                            <span>Tipo : {order.Customer.customerAddress?.typeAddress === 'main' ? 'Casa' : 'Entrega'}</span>
                                            <span>Distrito: {order.Customer.customerAddress?.district}</span>
                                            <span>Estado: {order.Customer.customerAddress?.state}</span>

                                        </div>

                                        <div className="clienteDadosEndereco">
                                            <span>Cidade: {order.Customer.customerAddress?.city} </span>
                                            <span>Rua: {order.Customer.customerAddress?.street} </span>
                                            <span>Nº {order.Customer.customerAddress?.number}</span>

                                        </div>
                                    </div>
                                </div>
                            )

                            }
                        </div>
                    )
                        */}
          <div id="compartilhaLink" className="compartilhaLink">
            {status(order) === "pending" && (
              <div className="compartilhaLinkBotao">
                <CopyToClipboard
                  text={
                    order.urlcart && order.guid
                      ? `${order.urlcart}${order.guid}`
                      : ""
                  }
                  onCopy={() =>
                    Swal.fire({
                      icon: "success",
                      title: "Carrinho copiado com sucesso!",
                    })
                  }
                >
                  <button className="btn textBtn">
                    Compartilhar link
                    <span>
                      {" "}
                      <ShareIcon color={"grey"} activeColor={"blue"} />{" "}
                    </span>
                  </button>
                </CopyToClipboard>
              </div>
            )}
          </div>
        </div>
      )}
      <div className="order-content">
        <hr className="hr" />
        <p className="data"> Data: {datetimeToDateBR(order.created)}</p>
      </div>
    </div>
  );
}

const AddressCustomer: FC<any> = ({ address }: any) => {
  return (
    <div id="clienteDadosEndereco" className="clienteDadosEnderecoMain">
      <div className="clienteDadosEndereco">
        <span>
          Tipo : {address?.typeAddress === "main" ? "Casa" : "Entrega"}
        </span>
        <span>Distrito: {address?.district}</span>
        <span>Estado: {address?.state}</span>
      </div>

      <div className="clienteDadosEndereco">
        <span>Cidade: {address?.city} </span>
        <span>Rua: {address?.street} </span>
        <span>Nº {address?.number}</span>
      </div>
    </div>
  );
};

const InfoCustomer: FC<any> = ({ order }: vendorOrderItemProps) => {
  function customerName(order: any) {
    var nameCustomer = "";

    if (order.Order) {
      nameCustomer = order.Order?.Customer?.name ?? "";
    } else if (order.Customer) {
      nameCustomer = order.Customer.name;
    } else {
      nameCustomer = order.customerName;
    }

    //name = order.Order?.Customer?.name ? order.Order.Customer.name : (order?.Customer?.name ? order?.Customer?.name : order.customerName)

    return nameCustomer ?? 'Cliente não encontrado'; 
  }

  function customerDoc(order: any) {
    let name = "";

    name = order.Order?.Customer?.doc
      ? order.Order.Customer.doc
      : order?.Customer?.doc
      ? order?.Customer?.doc
      : order.cpfCustomer;

    return name ?? 'Cliente sem documento';
  }

  function customerEmail(order: any) {
    let email = "";
    email = order.Order?.Customer?.email
      ? order.Order.Customer.email
      : order.Customer?.email
      ? order.Customer.email
      : "";

    return email;
  }

  function customerAddress(order: any) {
    let address = null;

    if (order.jsonCart?.address) {
      address = order.jsonCart?.address;
    } else if (order.Customer) {
      address = order.Customer?.customerAddress
        ? order.Customer?.customerAddress
        : null;
    } else if (order.Order?.Customer) {
      address = order.Order.Customer?.customerAddress
        ? order.Order.Customer?.customerAddress
        : null;
    }

    return address;
  }

  return (
    <div id="clienteDados" className="resumoCliente">
      <div className="clienteDadosTitulo">
        <h3>Dados do Cliente</h3>
      </div>
      <div id="clienteDadosInfo" className="clienteDadosInfo">
        {customerName(order) && <span>Nome: {customerName(order) ?? 'Cliente não encontrado'}</span>}
        {customerDoc(order) && (
          <span>Documento: {cpfMask(customerDoc(order)) ?? 'Sem documento'}</span>
        )}
        {customerEmail(order) && <span>Email: {customerEmail(order) ?? 'Sem email encontrado'}</span>}

        {customerAddress(order) && (
          <AddressCustomer address={customerAddress(order)} />
        )}
      </div>
    </div>
  );
};
